<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				:class="$vuetify.breakpoint.xs ? 'ml-2 pa-1 mx-2 my-1' : 'ml-2'"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-magnify</v-icon>
				検索
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">依頼検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" lazy-validation>
				<v-checkbox
					v-if="approvalFlag"
					v-model="showSentFlag"
					label="承認済みを含める"
				></v-checkbox>
				<v-checkbox
					v-if="confirmationFlag"
					v-model="showConfirmedFlag"
					label="確認済みを含める"
				></v-checkbox>
				<v-select
					label="種類"
					:items="requirementTypes"
					item-text="name"
					item-value="id"
					required
					v-model="selectedTypeId"
					hint="依頼の種類を選択してください"
					no-data-text="選択肢がありません"
					class=""
					outlined
					dense
					@change="getMembers"
				/>
				<v-select
					v-if="!approvalFlag && !confirmationFlag"
					label="状態"
					:items="statusAndJapanese"
					item-text="text"
					item-value="value"
					:rules="[]"
					v-model="selectedStatusWord"
					hint="依頼の状況を選択してください"
					no-data-text="選択肢がありません"
					class=""
					multiple
					outlined
					dense
				/>

				<v-select
					label="依頼者"
					:items="userList"
					:item-text="(item) => item.last_name + ' ' + item.first_name"
					item-value="id"
					:rules="[]"
					v-model="selectedUserId"
					hint="依頼者を選択してください"
					:no-data-text="selectedTypeId ? '選択肢がありません' : '依頼の種類を選択してください。'"
					class=""
					multiple
					outlined
					dense
				/>

				<v-select
					v-if="!approvalFlag && !confirmationFlag"
					label="担当者"
					:items="responderList"
					:item-text="(item) => item.last_name + ' ' + item.first_name"
					item-value="id"
					:rules="[]"
					v-model="selectedResponderId"
					hint="担当者を選択してください"
					no-data-text="選択肢がありません"
					class=""
					multiple
					outlined
					dense
				/>

				<p class="mb-2" v-if="!approvalFlag && !confirmationFlag">依頼日の範囲</p>
				<v-row no-gutters justify="space-between">
					<v-col cols="5">
						<v-text-field
							v-if="!approvalFlag && !confirmationFlag"
							label="以上"
							type="date"
							v-model="requirementDayLower"
							dense
							outlined
							:rules="[]"
							class=""
							hint="依頼日の範囲（下限）を入力してください"
						/>
					</v-col>

					<v-col cols="5">
						<v-text-field
							v-if="!approvalFlag && !confirmationFlag"
							label="以下"
							type="date"
							v-model="requirementDayUpper"
							dense
							outlined
							:rules="[]"
							class=""
							hint="依頼日の範囲（上限）を入力してください"
						/>
					</v-col>
				</v-row>

				<p class="mb-2">希望納期の範囲</p>
				<v-row no-gutters justify="space-between">
					<v-col cols="5">
						<v-text-field
							label="以上"
							type="date"
							v-model="deadlineLower"
							dense
							outlined
							:rules="[]"
							class=""
							hint="希望納期の範囲（下限）を入力してください"
						/>
					</v-col>
					<v-col cols="5">
						<v-text-field
							label="以下"
							type="date"
							v-model="deadlineUpper"
							dense
							outlined
							:rules="[]"
							class=""
							hint="希望納期の範囲（上限）を入力してください"
						/>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-text-field
						label="案件を検索"
						dense
						outlined
						:rules="[rules.moreThanThree]"
						class="mt-4"
						hint="絞り込みしたい案件の見積番号・受注番号・製造番号を入力してください。"
						v-model="searchWord"
					/>
					<v-btn
						class="ma-2 pa-2 mt-4"
						:disabled="!searchWord"
						color="primary"
						@click="searchMatters"
						>検索</v-btn
					>
				</v-row>
				<v-row v-if="searchedMatters" align="center" justify="space-around">
					<v-btn
						height="auto"
						class="ma-2 pa-2"
						depressed
						v-for="matter in searchedMatters"
						:key="matter.id"
						@click="setMatter(matter)"
					>
						<div class="text-left">
							<p v-if="matter.name">{{ matter.name }}</p>
							<p v-if="matter.quotation_number">
								{{ "見積番号:" + matter.quotation_number }}
								{{ "-" + matter.quotation_sub_number }}
							</p>
							<p v-if="matter.order_number">
								{{ matter.order_number ? "受注番号:" + matter.order_number : "" }}
							</p>
							<div v-if="matter.order_number">
								<p v-for="(op, index) in matter.ordered_products" :key="'op-' + op.id">
									製番{{ index + 1 }}:{{ op.product_number }}
								</p>
							</div>
						</div>
					</v-btn>
				</v-row>
				<v-card class="mx-auto my-2" v-for="(matter, index) in selectedMatter" :key="matter.id">
					<v-card-text>
						<v-flex class="justify-space-between">
							<div>
								<p>案件名：{{ matter.name }}</p>
								<p>見積番号：{{ matter.quotation_number }}-{{ matter.quotation_sub_number }}</p>
								<p>受注番号：{{ matter.order_number }}</p>
								<p>得意先：{{ matter.regular_customer_company.name }}</p>
								<p>向け先：{{ matter.customer_company.name }}</p>
								<p v-if="matter.contract">
									製番：
									<span class="d-inline-block" v-for="op in matter.ordered_products" :key="op.id">{{
										op.product_number
									}}</span>
								</p>
							</div>
							<v-icon @click="removeMatter(index)">mdi-close</v-icon>
						</v-flex>
					</v-card-text>
				</v-card>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4">
						<v-row no-gutters justify="start">
							<v-btn color="grey darken-1" text @click="resetSearchKeys()"> リセット </v-btn>
						</v-row>
					</v-col>
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="selectUrl()">
								<v-icon class="mr-1" :disabled="toggleDisabled">mdi-magnify</v-icon>
								検索する
							</v-btn>
						</v-row>
					</v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"

import rules from "../../../helper/rules"

function initialState() {
	return {
		toggleDisabled: false,
		rules: rules,
		multi: [],
		dialog: false,
		allRequired: false,
		selectedStatusWord: [],
		selectedTypeId: "",
		selectedUserId: [],
		selectedResponderId: [],
		userList: [],
		responderList: [],
		requirementDayLower: "",
		requirementDayUpper: "",
		deadlineLower: "",
		deadlineUpper: "",
		searchWord: "",
		selectedMatter: [],
		searchedMatters: [],
		statusAndJapanese: [],
		selectedMatterId: "",
		showSentFlag: false,
		showConfirmedFlag: false,
	}
}
export default {
	props: {
		text: Boolean,
		statusIdsHash: Object,
		requirementTypes: [],
		approvalFlag: Boolean,
		confirmationFlag: Boolean,
		departmentId: "",
	},
	data() {
		return initialState()
	},
	methods: {
		setMatter(matter) {
			this.searchedMatters = []
			this.selectedMatter.push(matter)
		},
		removeMatter(index) {
			this.selectedMatter.splice(index, 1)
		},
		searchMatters() {
			this.searchedMatters = []
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/matter_search.json", {
					headers,
					params: {
						q: { quotation_number_or_order_number_cont: this.searchWord },
						qq: { product_number_cont: this.searchWord },
					},
				})
				.then((response) => {
					this.searchedMatters = response.data.matters
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		getMembers() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/requirement_types/members/" + this.selectedTypeId + ".json", { headers })
				.then((response) => {
					this.userList = response.data.from_department_users
					this.responderList = response.data.to_department_users
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		resetSearchKeys() {
			Object.assign(this.$data, initialState())
			this.dialog = true
		},
		selectUrl() {
			if (this.approvalFlag) {
				this.getResultForApproval()
			} else if (this.confirmationFlag) {
				this.getResultForConfirmation()
			} else {
				this.getResult()
			}
		},
		getResult(page) {
			this.toggleDisabled = true
			let matterIds = this.selectedMatter.map((matter) => matter.id)
			const headers = authenticate.setHeader()
			let params = {
				user_id_eq_any: this.selectedUserId,
				responder_id_eq_any: this.selectedResponderId,
				status_ids: this.selectedStatusWord,
				requirement_type_id_eq: this.selectedTypeId,
				deadline_gteq: this.deadlineLower,
				deadline_lteq: this.deadlineUpper,
				requirement_date_qteq: this.requirementDayLower,
				requirement_date_lteq: this.requirementDayUpper,
				matter_id_eq_any: matterIds,
				show_sent_flag: this.showSentFlag,
			}
			axios
				.get("/erp/v1/requirement_search.json", {
					headers,
					params: { q: params, page: page, responder_present: true },
				})
				.then((response) => {
					this.toggleDisabled = false
					this.$emit("setSearchedList", response.data.requirements, response.data.pagination)
					this.dialog = false
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		getResultForApproval() {
			this.toggleDisabled = true
			let matterIds = this.selectedMatter.map((matter) => matter.id)
			const headers = authenticate.setHeader()
			let params = {
				user_id_eq_any: this.selectedUserId,
				responder_id_eq_any: this.selectedResponderId,
				status_ids: this.selectedStatusWord,
				requirement_type_id_eq: this.selectedTypeId,
				deadline_gteq: this.deadlineLower,
				deadline_lteq: this.deadlineUpper,
				requirement_date_qteq: this.requirementDayLower,
				requirement_date_lteq: this.requirementDayUpper,
				matter_id_eq_any: matterIds,
				show_sent_flag: this.showSentFlag,
				department_id: this.departmentId,
			}
			axios
				.get("/erp/v1/requirement_search/for_approval.json", {
					headers,
					params: { q: params },
				})
				.then((response) => {
					this.toggleDisabled = false
					this.$emit("setSearchedList", response.data.requirements)
					this.dialog = false
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		getResultForConfirmation() {
			this.toggleDisabled = true
			let matterIds = this.selectedMatter.map((matter) => matter.id)
			const headers = authenticate.setHeader()
			let params = {
				user_id_eq_any: this.selectedUserId,
				responder_id_eq_any: this.selectedResponderId,
				status_ids: this.selectedStatusWord,
				requirement_type_id_eq: this.selectedTypeId,
				deadline_gteq: this.deadlineLower,
				deadline_lteq: this.deadlineUpper,
				requirement_date_qteq: this.requirementDayLower,
				requirement_date_lteq: this.requirementDayUpper,
				matter_id_eq_any: matterIds,
				show_confirmed_flag: this.showConfirmedFlag,
				department_id: this.departmentId,
			}
			axios
				.get("/erp/v1/requirement_search/for_confirmation.json", {
					headers,
					params: { q: params },
				})
				.then((response) => {
					this.toggleDisabled = false
					this.$emit("setSearchedList", response.data.requirements)
					this.dialog = false
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		statusIdsHash() {
			if (this.statusIdsHash != null) {
				let keys = Object.keys(this.statusIdsHash)
				keys.forEach((key) => {
					this.statusAndJapanese.push({
						text: this.statusIdsHash[key],
						value: key,
					})
				})
			}
		},
	},
	computed: {},
}
</script>
